module.exports = __webpack_public_path__ + "static/media/franziskaschaadt.6657031a.webp";


//////////////////
// WEBPACK FOOTER
// ./src/images/letterfunnel/franziskaschaadt.webp
// module id = 420
// module chunks = 0